import * as React from 'react'
import { Link } from 'react-router-dom'
import { UsernameContext } from '../App'
import {saveAs} from 'file-saver'
import axios from '../services/index'
import pdfImage from "../Assets/64px-PDF_file_icon.svg.png"
import LinkedInIcon from "../Assets/linkedin.svg"
import FacebookIcon from "../Assets/facebook.png"


interface ITrainingDetailCard {
    id: string,
    name: string,
    price: Float32Array,
    summary: string,
    presentationId: string,
    videoId: string,
    isPaid: boolean,
    facebookLink: string,
    googleFormLink: string,
    duration: string,
    pedagogicalMethods: string,
    objectives: string,
    detailledProgram: string,
    prerequisite: string,
}

//This component display the training to the user, regarding if user already own it or not.
export const TrainingDetailCard : React.FunctionComponent<ITrainingDetailCard> = (props) => {

    const {currentUsername, setCurrentUsername} = React.useContext(UsernameContext)
    const currentToken = localStorage.getItem('access_token')

    let pdfLink = ''

    const getPDF = async() => {
        let headerValue = {}
        if(currentToken) {
            headerValue = {
                headers: {
                    "Authorization": `Bearer ${currentToken}`
                }
            }
        }

        await axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/pdftraining/${props.id}/`, headerValue)
        .then(function (response: any) {
            console.log(response.data.pdfLink)
            return pdfLink = response.data.pdfLink
        })
        .catch(function(error: any) {
            console.log(error);
        })
    }

    const downloadPDF = () => {
        getPDF()
        .then(() => {
            let binary = atob(pdfLink.replace(/\s/g,''));
            var buffer = new ArrayBuffer(binary.length);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < binary.length; i++) {
                view[i] = binary.charCodeAt(i)
            }
            var blob = new Blob( [view], {type: "application/pdf"});
            saveAs(blob, `${props.name}.pdf`)
        })
        .catch((error) => {
            alert('Une erreur est survenue ! Veuillez réessayer.')
        })
    }


    const displayIfNotPaid = () => {
        if (!props.isPaid) {
            return(
                <div>
                    <h3 className="BuyH3"> Cette formation vous <span className="BuyH3SubPart">intéresse ?</span> Vous pouvez la suivre pour le prix de <span className="BuyH3SubPart">{props.price}€</span> </h3>
                    <Link to={{pathname: currentUsername?`/training/${props.id}/buy`:"/connexion", state: currentUsername?{name: props.name, price: props.price}:{}}}><button className="ConnectButton Connexion BuyButton">Acheter : {props.price}€</button></Link>
                </div>
            )
        }
    }

    const displayIfPaid = () => {
        if (props.isPaid) {
            return(
                <div>
                    <h3>Vidéo Complète</h3>
                    <div className="Wrapper"><div className="CenterVideo"><iframe className="CenterVideoItem" src={`https://player.vimeo.com/video/${props.videoId}?title=0&byline=0&portrait=0`} allow="autoplay; fullscreen" allowFullScreen title="formation"></iframe></div></div>
                    <h3>Documentation écrite</h3>
                    <p className="Description">Vous trouverez sur le PDF ci-dessous l'ensemble des documents utiles à cette formation.</p>
                    <div className="ConnectButton Connexion BuyButton LoadButton" onClick={downloadPDF}>
                        <img src={pdfImage} height={45} alt="pdf"></img><span className="LoadButtonText"> Télécharger PDF</span>
                    </div>
                    <h3>Lieu d'échange sur cette formation</h3>
                    <div className="Description">Vous retrouverez sur ce lien une page privée facebook vous permettant 
                        d'échanger entre stagiaires et avec la formatrice.</div>
                        <a className="ConnectButton Connexion" href={props.facebookLink} target="_blank" rel="noreferrer noopener">Rejoindre le groupe Facebook</a>
                    <h3>Attestation</h3>
                    <div className="Description">Afin de valider votre formation, après avoir suivi les différents éléments la constituant, nous vous invitons à passer le questionnaire ci-dessous à la suite duquel une attestation de réussite vous sera délivrée.</div>
                        <a className="ConnectButton Connexion" href={props.googleFormLink} target="_blank" rel="noreferrer noopener">Aller au questionnaire</a>
                </div>
            )
        }
    }

    const displayObjectives = () => {
        let objectivesList: Array<string> = props.objectives.split('_')
        objectivesList = objectivesList.slice(1)
        return objectivesList.map((objective) => {return(<div className="Description">{objective}</div>)})
    }

    const displayListOfStrings = (stringBloc: string) => {
        let detailledProgramList: Array<string> = stringBloc.split('_')
        if(detailledProgramList.length > 1) {
            detailledProgramList = detailledProgramList.slice(1)
        }
        return detailledProgramList.map((sentence) => {return(<div className="Description">{sentence}</div>)})
    }

    const displayPresentationVideo = () => {
        if (!props.isPaid) {
            return(
                <div>
                    <h3>Video de présentation : </h3>
                    <div className="Wrapper"><div className="CenterVideo"><iframe className="CenterVideoItem" src={`https://player.vimeo.com/video/${props.presentationId}`} allow="autoplay; fullscreen" allowFullScreen title="presentation"></iframe></div></div>
                </div>
            )
        }
    }

    const displayValidationMethods = () => {
        if (!props.isPaid) {
            return(
                <div>
                    <h3>Validation de la Formation</h3>
                    <div className="Description">La validation de cette formation sera réalisée par le biais d'un questionnaire. A la suite de ce dernier, vous pourrez solliciter une attestation de suivi de cette formation.</div>
                </div>
            )
        }
    }

    const shareOnSocialMedia = () => {
        return(
            <div className="ShareButtons">
                <div className="ShareItems ShareTitle">Partager : </div>
                <a className="ShareItems" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(window.location.href)}`} target="_blank" onClick={(e) => {e.stopPropagation()}}><img src={FacebookIcon} height={28} alt="Facebook"></img></a>
                <a className="ShareItems" href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURI(window.location.href)}`} target="_blank" onClick={(e) => {e.stopPropagation()}}><img src={LinkedInIcon} height={28} alt="LinkedIn"></img></a>
            </div>
        )
    }

    return (
        <div>
            <h2>{props.name}</h2>
            {displayIfNotPaid()}
            {shareOnSocialMedia()}
            <h3>Description</h3>
            <div className="Description">{props.summary}</div>
            <h3>Objectifs</h3>
            {displayObjectives()}
            {displayPresentationVideo()}
            {displayIfPaid()}
            <h3>Programme Détaillé</h3>
            {displayListOfStrings(props.detailledProgram)}
            <h3>Durée</h3>
            <div>{props.duration}</div>
            <h3>Public</h3>
            <div className="Description">Professionnel de la relation d'aide en lien avec des endeuillés, psy, coach, thérapeute, soignant, enseignant, aide à domicile, assistant de vie, vous travaillez dans le funéraire, vous intervenez dans une association de soutien au deuil, vous êtes un particulier qui veut accompagner bénévolement des endeuillés...</div>
            <div>Nous attirons votre attention sur le fait que ceci est une formation et non une thérapie.</div>
            <h3>Prérequis</h3>
            {displayListOfStrings(props.prerequisite)}
            <h3>Méthodes Pédagogiques</h3>
            {displayListOfStrings(props.pedagogicalMethods)}
            {displayValidationMethods()}
            <h3>Formatrice</h3>
            <div className="Description">Laurence Brun, thérapeute du deuil, titulaire d’un
Diplôme d'Etat d'Assistant de Service Social et d’un Diplôme Universitaire : Deuil et Travail de deuil. <br />Enregistrée sous le
numéro 72 64 03766 64 en tant que formatrice professionnelle
avec plus de 7 ans d’expérience.</div>
            <h3>Lieu de Formation</h3>
            <div className="Description EndOfPage">Plateforme de formation en distanciel www.en-deuil-et.com/eformations </div>
            <Link to="/"><button className="ConnectButton Connexion BuyButton LoadButton ReturnButton">Retour aux formations</button></Link>
            <div className="EndOfPage"></div>
        </div>
    )
}